import {MNullable} from '../../Toolkit/Utils';
import * as Yup from 'yup';
import {CrewContactData} from './WorkMailTypes';
import NSwagAdapter from '../../Toolkit/Api/NSwagAdapter';
import {AnySchema} from 'yup';
import {CrewClient} from '../CrewClient';

export class Assignment {
    public requestId: string = "";
    public tmTypes: string = "";
}

export class Crew {
    public static readonly CrewNameMaxLength = 50;
    public static readonly WorkAreaMaxLength = 255;
    public static readonly HighlightMaxLength = 6;

    public id: number = 0;
    public crewName: string = '';
    public crewType: number = 0;
    public workArea: string = '';
    public assignedJobs: Assignment[] = [];
    public primaryContact?: number;
    public highlightColour: string = '';
    public active: boolean = true;
};

export class CrewContact {
    public id: number = 0;
    public crewId: number = 0;
    public contactType: number = 0;
    public description: string = '';
    public contact: string = '';
};

export class CrewData {
    public crew: Crew = new Crew();
    public primaryContact: CrewContact | undefined;
}

export class CrewContactList {
    public crew?: Crew = undefined;
    public crewContacts: CrewContact[] = [];
}

export class CreateCrewValidator {
    public static crewNameFunc(crewClient: NSwagAdapter<CrewClient>, newCrew: boolean): AnySchema {
        return Yup.string().label('CrewName').max(Crew.CrewNameMaxLength).required().test(
            'crewNameDuplicate',
            'Crew Name and Type must be unique',
            function crewDuplicate(value): Promise<boolean> {
                if(this.parent.crewType !== undefined) {
                    return new Promise(async(resolve, reject) => {
                        const result = await crewClient.callWithReply(CrewDuplicateReply,
                            (client) => client.getDuplicateCrews(this.parent.crewName, this.parent.crewType, newCrew ? null : this.parent.id));
                        result.throwIfFailed();

                        if(result.reply!.crewExists) {
                            //Crew is not unique so cancel the update.
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    });
                }
                return new Promise(async(resolve, reject) => {
                    resolve(true);
                });
            }
        );
    };
    public static crewTypeFunc(crewClient: NSwagAdapter<CrewClient>, newCrew: boolean): AnySchema {
        return  Yup.number().label('CrewType').min(0).max(255).required().test(
        'crewTypeDuplicate',
        'Crew Name and Type must be unique',
        function crewDuplicate(value): Promise<boolean> {
            if(this.parent.crewName !== undefined) {
                return new Promise(async(resolve, reject) => {
                    const result = await crewClient.callWithReply(CrewDuplicateReply,
                        (client) => client.getDuplicateCrews(this.parent.crewName, value, newCrew ? null : this.parent.id));
                    result.throwIfFailed();

                    if(result.reply!.crewExists) {
                        //Crew is not unique so cancel the update.
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                });
            }
            return new Promise(async(resolve, reject) => {
                resolve(true);
            });
        })
    };
    public static readonly workArea = Yup.string().label('WorkArea').max(Crew.WorkAreaMaxLength).optional();
};

export class UpdateCrewValidator {
    public static readonly id = Yup.number().label('CrewId').required();
    public static readonly crewName = Yup.string().label('CrewName').max(Crew.CrewNameMaxLength).required();
    public static readonly crewType = Yup.number().label('CrewType').min(0).max(255).required();
    public static readonly workArea = Yup.string().label('WorkArea').max(Crew.WorkAreaMaxLength).optional();
}

export class CrewDataMultiReply {
    public crews: CrewData[] = [];
};

export class CrewDataReply {
    public crew: MNullable<CrewData> = null;
};

export class CrewContactListReply {
    public crews: CrewContactData[] = [];
}

export class CrewDuplicateReply {
    public crewExists: boolean = false;
}
